import { Form, Formik } from "formik";
import AdminFormLayout, { FormSection } from "../../components/common/form-layout/AdminFormLayout";
import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../../utils/toastify-message/ToastifyMessage";
import { postApi, putApi } from "../../services/api/globalApi";
import Input from "../../components/common/inputs/Input";
import Button from "../../components/common/button/Button";
import { faqValidation } from "../../utils/validation/faqValidation";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import TextArea from "../../components/common/inputs/TextArea";
import Select from "../../components/common/inputs/Select";
import ImagesModal from "../../components/common/modals/imgaes-modal/ImagesModal";
import { useRef, useState } from "react";
import Editor from "../../components/common/ck-editor/CkEditor";

export default function FAQ() {
  const location = useLocation();
  const navigate = useNavigate();

  const { utils } = useSelector(utilsState);

  const [answer, setAnswer] = useState("");

  const formHandler = async (values, { resetForm }) => {
    if (answer.length) {
      const body = {
        ...values,
        answer,
        priority: Number(values?.priority),
      };
      try {
        if (location.state) {
          await putApi({
            path: `admin/faq/${location.state?.id}`,
            body: JSON.stringify(body),
          });
          successMessage("سوال با موفقیت ویرایش شد");
        } else {
          await postApi({
            path: "admin/faq",
            body: JSON.stringify(body),
          });
          successMessage("سوال با موفقیت اضافه شد");
        }
        resetForm();
        navigate("/faq-list");
      } catch (error) {
        console.error(error);
        errorMessage(error?.response?.data?.errors[0].message);
      }
    } else {
      warningMessage("لطفا پاسخ سوال را پر کنید");
    }
  };

  const copyImagesUrlModal = useRef();

  return (
    <>
      <AdminFormLayout title={location?.state ? "ویرایش سؤال متداول" : "افزودن سؤال متداول"} description="عنوان سؤال، محل نمایش و پاسخ آن را با دقت تکمیل کنید.">

        <Formik
          enableReinitialize
          initialValues={{
            title: location?.state?.title || "",
            part: location?.state?.part || "",
            video: location?.state?.video || "",
            priority: location?.state?.priority || "",
          }}
          validationSchema={faqValidation}
          onSubmit={formHandler}
        >
          {(formik) => (
            <Form>
              <div className="mt-6">
                <div className="grid gap-6 mb-4 md:grid-cols-2">
                  <Input
                    name="title"
                    placeholder="عنوان"
                    label="عنوان"
                    type="text"
                  />

                  <Select name="part" placeholder="بخش" label="بخش">
                    <option value={""} selected>
                      انتخاب بخش
                    </option>
                    {utils
                      ? utils.FAQ_PART_VALUES.map((item) => {
                          return (
                            <option value={item.value}>{item?.name}</option>
                          );
                        })
                      : null}
                  </Select>
                  <Input
                    name="priority"
                    placeholder="الویت"
                    label="الویت"
                    type="text"
                  />
                  <Input
                    name="video"
                    placeholder="آدرس ویدئو"
                    label="آدرس ویدئو"
                    type="text"
                  />
                </div>
                <Button
                  type="button"
                  onClick={() => copyImagesUrlModal.current.showModal()}
                  text={"انتخاب عکس"}
                  color={"primary"}
                  className="mb-3"
                />

                <FormSection title="پاسخ سؤال" description="پاسخ کامل سؤال را در این بخش بنویسید.">
                <Editor
                  onChange={setAnswer}
                  defultData={location?.state?.answer || null}
                />
                </FormSection>

                <div className="flex flex-col gap-y-2">
                  <div className="admin-form-actions">
                    <Button disabled={formik.isSubmitting} loading={formik.isSubmitting}
                      text={location?.state ? "ویرایش" : "افزودن"}
                      type="submit" color="success"
                    />
                    <button type="button" className="admin-form-cancel" onClick={() => navigate("/faq-list")}>انصراف</button>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </AdminFormLayout>
      <ImagesModal selectImg={false} ref={copyImagesUrlModal} />
    </>
  );
}
